import { render, staticRenderFns } from "./election-select.vue?vue&type=template&id=1e63c7a5"
import script from "./election-select.vue?vue&type=script&lang=js"
export * from "./election-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports